import { createActions } from 'redux-actions';

export const { updateFieldTypes } = createActions('UPDATE_FIELD_TYPES');
